import React from 'react';
import { InvestmentHoldingType, InvestmentHoldingSubtype } from 'src/types/investment-holding.model';

import { AddAccountFormViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import AddAccountFormContainer from '../../AddAccountFormContainer';

export default function CertificateOfDepositForm({
    manualAccount,
    onSubmit,
    handleBack
}: AddAccountFormViewModel): JSX.Element {
    return (
        <AddAccountFormContainer
            manualAccount={manualAccount}
            onSubmit={(values) => {
                void onSubmit(
                    values,
                    manualAccount,
                    false,
                    InvestmentHoldingType.Cash,
                    InvestmentHoldingSubtype.CertificateOfDeposit
                );
            }}
            handleBack={handleBack}
        />
    );
}
